import BrandLogo from "/static/images/tenants/keychron/keychron_white.svg";
import { keychronContent } from "../brandContent/keychronBrandContent";
import { keychronTypingShooter } from "../brandThemes/keychron-ts";
import { keychronTypingShooterPrize } from "../brandPrize/keychronTypingShooterPrize";

export const KEYCHRONTYPINGSHOOTER_brandVariables = {
  tenantId: "keychron-kzk8f", // For picking wich leaderboard to show
  themeId: "keychron",
  gameStyle: "typingshooter", // For picking wich leaderboard to show
  eventCode: "", // Needed for fetching correct challenge
  gameType: "typingshooter", // What challenge game
  brandLogoType: "element", // "img" | "element" (svg)
  brandLogo: BrandLogo,
  brandLogoSize: 400,
  theme: keychronTypingShooter,
  content: keychronContent,
  prize: keychronTypingShooterPrize,

  leaderboardLength: 5,
  disclaimer: "Set the fastest time and win a",
};
